import lottie from 'lottie-web'

// Lottie  Animations
const lottieAnimation = () => {
  let animation
  const face1 = document.querySelector('.lottie-circle__face-1')
  const face2 = document.querySelector('.lottie-circle__face-2')
  const face3 = document.querySelector('.lottie-circle__face-3')
  const face4 = document.querySelector('.lottie-circle__face-4')
  const face5 = document.querySelector('.lottie-circle__face-5')
  const face6 = document.querySelector('.lottie-circle__face-6')
  const face7 = document.querySelector('.lottie-circle__face-7')
  const face8 = document.querySelector('.lottie-circle__face-8')

  if (face1) {
    animation = lottie.loadAnimation({
      container: face1,
      renderer: "svg",
      loop: true,
      autoplay: true,
      path: "/assets/faces_nina-schmidt.json"
    })
  }

  if (face2) {
    animation = lottie.loadAnimation({
      container: face2,
      renderer: "svg",
      loop: true,
      autoplay: true,
      path: "/assets/faces_ding-cheng.json"
    })
  }

  if (face3) {
    animation = lottie.loadAnimation({
      container: face3,
      renderer: "svg",
      loop: true,
      autoplay: true,
      path: "/assets/faces_bok-oh.json"
    })
  }

  if (face4) {
    animation = lottie.loadAnimation({
      container: face4,
      renderer: "svg",
      loop: true,
      autoplay: true,
      path: "/assets/faces_joanne-maki.json"
    })
  }

  if (face5) {
    animation = lottie.loadAnimation({
      container: face5,
      renderer: "svg",
      loop: true,
      autoplay: true,
      path: "/assets/faces_missy-pappion.json"
    })
  }

  if (face6) {
    animation = lottie.loadAnimation({
      container: face6,
      renderer: "svg",
      loop: true,
      autoplay: true,
      path: "/assets/faces_trent-bliss.json"
    })
  }

  if (face7) {
    animation = lottie.loadAnimation({
      container: face7,
      renderer: "svg",
      loop: true,
      autoplay: true,
      path: "/assets/faces_fangya-qiang.json"
    })
  }

  if (face8) {
    animation = lottie.loadAnimation({
      container: face8,
      renderer: "svg",
      loop: true,
      autoplay: true,
      path: "/assets/faces_marzieh-funk.json"
    })
  }
}

// Click Overlays
const clickOverlays = () => {
  const tabs = document.querySelectorAll('.faces__item')

  const openTab = (tab) => {
    tab.classList.add('active')
  }
  
  const closeTab= (tab) => {
    tab.classList.remove('active')
  }

  if (tabs.length) {
    tabs.forEach((tab) => {
      const tabHeader = tab.querySelector('.tooltip-icon')
      if (tab.classList.contains('active')) {
        openTab(tab)
      }

      tabHeader.addEventListener('click', () => {
        if (tab.classList.contains('active')) {
          closeTab(tab)
        } else {
          tabs.forEach((tab) => closeTab(tab))
          openTab(tab)
        }
      })
    })
  }
}

const facesInit = () => {
  lottieAnimation()
  clickOverlays()
}

facesInit()